/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Filters/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AppChooser from './AppChooser/index'
import LocationChooser from './LocationChooser/index'
import NextAppointmentDateRange from './NextAppointmentDateRange/index'
import NextAppointmentTypeChooser from './NextAppointmentTypeChooser/index'
import React from 'react'
import StatusChooser from './StatusChooser/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Filters({
  children,
  viewPath = "/App/Account/Content/Orders/Filters"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Filters.Horizontal"
  data-view-path={viewPath}
 style={{'--ml-1-Wv2Qg': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mr-2-Wv2Qg': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<LocationChooser
  viewPath={`${viewPath}/LocationChooser`}
/>
<StatusChooser
  viewPath={`${viewPath}/StatusChooser`}
/>
<NextAppointmentDateRange
  viewPath={`${viewPath}/NextAppointmentDateRange`}
/>
<NextAppointmentTypeChooser
  viewPath={`${viewPath}/NextAppointmentTypeChooser`}
/>
<AppChooser
  viewPath={`${viewPath}/AppChooser`}
/>
</div>
{children}
</React.Fragment>)
}